export const VRCHAT_TOS_URL = 'https://www.vrchat.com/legal';
export const VRCHAT_HOME_URL = 'https://www.vrchat.com/home';
export const VRCHAT_COMMUNITY_GUIDELINES_URL = 'https://www.vrchat.com/community-guidelines';

export const FURALITY_MAIN_WEBSITE_LINK = 'https://furality.org/';
export const FURALITY_CODE_OF_CONDUCT = 'https://furality.org/codeofconduct';
export const FURALITY_PRIVACY_POLICY = 'https://furality.org/privacypolicy';
export const FURALITY_CONVENTION_STORE_URL = 'https://store.furality.org';
export const FURALITY_TWITTER = 'https://twitter.com/furality';
export const FURALITY_TELEGRAM = 'https://t.me/furality';
export const FURALITY_BLUESKY = 'https://bsky.app/profile/furality.org';
export const FURALITY_MASTODON = 'https://floofy.tech/@furality';
export const FURALITY_DISCORD_SUPPORT = 'https://discord.com/servers/furality-693598922064789635';
export const FURALITY_MAIL_TO_HELP = 'mailto:help@furality.org';

//export const SAVEAFOX_URL = 'https://www.saveafox.org/home';
//export const EQUALITY_INSTITUTE_URL = 'https://www.eqfl.org/';
//export const THE_CENTER_ORLANDO_URL = 'https://thecenterorlando.org/';
export const RESILIENT_HEARTS_URL = 'https://resilientheartsanimalsanctuary.org/';

export const DISCORD_INVITE_URL = 'https://discord.gg/furality';
export const VRCHAT_LOGIN_URL =
  'https://vrchat.com/home/sso/furality?redirect=https%3A%2F%2Ffurality.online%2Flogin';
export const VRCHAT_REQUIREMENTS_URL =
  'https://help.vrchat.com/hc/en-us/articles/1500002378722-System-Requirements';

export const FURALITY_MIXCLOUD = 'https://www.mixcloud.com/live/furality/';
export const FURALITY_CLUB_TWITCH = 'https://www.twitch.tv/FuralityClubFYNN';
export const FURALITY_TWITCH = 'https://www.twitch.tv/furality';

export const FURALITY_GROUP_NAME = 'Furality Team';

// CON-SPECIFIC: event name
export const CON_NAME = 'Flower Festival';

export const YOUTUBE_BADGE_TUTORIAL_URL = 'https://youtu.be/hbPblO8O4Q8';

export const SURVEY_TYPEFORM_CODE = 'WpODqfP1';

export const matomoUrl = import.meta.env.PUBLIC_MATOMO_URL ?? '';
export const matomoSiteId = parseInt(import.meta.env.PUBLIC_MATOMO_SITE_ID ?? '');

// users if the player cap exceeds this amount
export const INSTANCE_CAP_WARN_AMOUNT = 90;

// CON-SPECIFIC: con registration dates
export const EARLY_BIRD_CLOSES = new Date('2026-05-01T12:00-00:00');
export const PRE_REG_CLOSES = new Date('2026-06-01T12:00-00:00');

export const HARDSHIP_FORM_OPENS = new Date('2026-05-20T12:00:00-00:00');
